/* eslint-disable react/display-name */
import React from 'react';
import { Column, TableInstance, ColumnInstance } from 'react-table';

import Header from './tableHeader';

import { GlobalSurveyType } from 'types/forms';

function contains(array: Array<string>, string: string): boolean {
  const index = array.findIndex(item => item === string);
  return index !== -1;
}

export default function useGlobalSurveyColumns(
  columnsList?: Array<string>,
): Array<Column<GlobalSurveyType>> {
  return React.useMemo((): Array<Column<GlobalSurveyType>> => {
    if (columnsList) {
      const columns = [];
      if (contains(columnsList, 'Title')) columns.push(getTitleHeader(Header));
      if (contains(columnsList, 'Notes')) columns.push(getNotesHeader(Header));
      if (contains(columnsList, 'Call taker can add to call'))
        columns.push(getCallTakerHeader(Header));

      return columns;
    }
    return [
      getTitleHeader(Header),
      getNotesHeader(Header),
      getCallTakerHeader(Header),
    ];
  }, [columnsList]);
}

function getTitleHeader(
  Header: (
    props: TableInstance<GlobalSurveyType> & {
      column: ColumnInstance<GlobalSurveyType>;
    },
  ) => JSX.Element,
): Column<GlobalSurveyType> {
  return {
    Header: Header,
    accessor: (row: GlobalSurveyType) => `${row.Title || ''}`,
    id: 'Title',
  };
}

function getNotesHeader(
  Header: (
    props: TableInstance<GlobalSurveyType> & {
      column: ColumnInstance<GlobalSurveyType>;
    },
  ) => JSX.Element,
): Column<GlobalSurveyType> {
  return {
    Header: Header,
    accessor: (row: GlobalSurveyType) => `${row.Notes || ''}`,
    id: 'Notes',
  };
}
function getCallTakerHeader(
  Header: (
    props: TableInstance<GlobalSurveyType> & {
      column: ColumnInstance<GlobalSurveyType>;
    },
  ) => JSX.Element,
): Column<GlobalSurveyType> {
  return {
    id: 'Call taker can add to call',
    Header: Header,
    accessor: (row: GlobalSurveyType) =>
      `${row.IsClinicianAllowedToAddToCall === true ? 'Yes' : 'No'}`,
  };
}
